/** @format */
import Master from '../../Layouts/Master';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useApi from '../../../Shared/hooks/api/Index';
import { error, success } from '../../../Shared/Components/Toast';
import ErrorMessage from '../../../Shared/Components/ErrorMessage';
import { useEffect } from 'react';
import { useContext } from 'react';
import { EventContext } from '../../../Contexts/EventContext';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import Loading from '../../../Shared/Components/Loading';

const validationSchema = Yup.object().shape({
	roles_id: Yup.array()
		.required('انتخاب نقش الزامی است')
		.min(1, 'حداقل باید یک نقش انتخاب کنید'),
});

const UserRole = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const eventContext = useContext(EventContext);
	const [submitFormLoading, setSubmitFormLoading] = useState(false);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const getRoles = async () => {
			setLoading(true);
			await useApi.get(
				`/panel/user/${id}`,
				{},
				(res) => {
					eventContext.user = res.data.data;
				},
				(err) => {
					setLoading(false);
					error('هنگام دریافت اطلاعات خطایی رخ داده است');
				},
			);
			await useApi.get(
				'/panel/role?all=1',
				{},
				(res) => {
					eventContext.roles = res.data.data;
					setLoading(false);
				},
				(err) => {
					setLoading(false);
					error('هنگام دریافت اطلاعات خطایی رخ داده است');
				},
			);
		};
		getRoles();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	const onSubmitForm = async (values, setSubmitting) => {
		setSubmitFormLoading(true);
		values['roles_id'] = values.roles_id.map((r) => r.id);
		values['user_id'] = eventContext.user.id;
		await useApi.post(
			'/panel/user/role',
			values,
			(res) => {
				success('نقش با موفقیت به کاربر داده شد');
				navigate('/panel/admin/users', { replace: true });
			},
			(err) => {
				setSubmitFormLoading(false);
				error('خطایی در ثبت اطلاعات پیش آمده است.');
			},
		);
	};
	return loading ? (
		<Loading />
	) : (
		<Master>
			<Formik
				initialValues={{
					roles_name: eventContext.user?.role ?? [],
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='row border rounded p-2 mt-3'>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group my-2'>
									<label className='text-dark-mode f-14 text-right'>نقش</label>
									<input
										type='text'
										disabled
										className='form-control'
										value={
											eventContext.user.name + ' ' + eventContext.user.last_name
										}
									/>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group my-2'>
									<label className='text-dark-mode f-14 text-right'>نقش</label>
									<Select
										isMulti
										defaultValue={eventContext.user?.roles}
										closeMenuOnSelect={false}
										options={eventContext.roles}
										onChange={(value) => setFieldValue('roles_id', value, true)}
										noOptionsMessage={() => 'لطفا نقش ها را انتخاب کنید'}
										getOptionLabel={(c) => c.description}
										getOptionValue={(c) => c.id}
										className='w-100'
										placeholder='انتخاب کنید...'
									/>
									<ErrorMessage classes='my-2' error={errors.roles_id} />
								</div>
							</div>
						</div>
						<div className='d-flex flex-row justify-content-end'>
							<button className='btn btn-info btn-sm f-14'>
								{submitFormLoading ? (
									<div
										className='spinner-border spinner-border-sm text-white mb-1'
										role='status'></div>
								) : (
									'ثبت نقش'
								)}
							</button>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default UserRole;
